// Shows Current Server Phase 
import React from 'react';
import '../stylesheets/style.css';

export default function DebugLog({ gameState }) {
    if (!gameState) {
        return null;
    }

    // Determine the current player's name
    const currentPlayerId = gameState.turnOrder[gameState.turnIndex];
    const currentPlayer = gameState.players[currentPlayerId];
    const name = currentPlayer?.name || '...';

    // Determine the message based on the game phase
    let message = '';
    switch (gameState.phase) {
        case 'awaitingMove':
            message = `${name}'s turn. Awaiting Roll.`;
            break;
        case 'awaitingDraw': 
            message = `${name}'s turn. Awaiting Draw.`;
            break;
        case 'awaitingEndTurn':
            message = `Awaiting Host's End Turn`;
            break;
        default:
            message = `Phase: ${gameState.phase}`;
            break;
    }

    return (
        <div className="debug-log-container">
            <p className="debug-log-text">{message}</p>
        </div>
    );
}
